import { useState } from "react";
import { useAuth } from "../context/AuthContext";

type Props = {
  onClose: () => void;
};

export function AuthModal({ onClose }: Props) {
  const { login, signup } = useAuth();
  const [tab, setTab] = useState<"login" | "signup">("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [handle, setHandle] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      if (tab === "login") {
        await login({ email, password });
      } else {
        await signup({ email, password, handle });
      }
      onClose();
    } catch (err) {
      const msg = err instanceof Error ? err.message : "Something went wrong";
      setError(msg.replace("API 400: ", "").replace("API 401: ", "").replace("API 422: ", ""));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal">
        <h2>NutOverdose</h2>

        <div className="modal-tabs">
          <button
            type="button"
            className={`modal-tab${tab === "login" ? " active" : ""}`}
            onClick={() => { setTab("login"); setError(""); }}
          >
            Sign in
          </button>
          <button
            type="button"
            className={`modal-tab${tab === "signup" ? " active" : ""}`}
            onClick={() => { setTab("signup"); setError(""); }}
          >
            Create account
          </button>
        </div>

        <form onSubmit={(e) => void handleSubmit(e)} style={{ display: "grid", gap: "12px" }}>
          {tab === "signup" && (
            <div className="form-group">
              <label htmlFor="auth-handle">Handle</label>
              <input
                id="auth-handle"
                type="text"
                placeholder="@nightowl"
                value={handle}
                onChange={(e) => setHandle(e.target.value)}
                required
                minLength={3}
                maxLength={32}
                autoComplete="username"
              />
            </div>
          )}

          <div className="form-group">
            <label htmlFor="auth-email">Email</label>
            <input
              id="auth-email"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="auth-password">Password</label>
            <input
              id="auth-password"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              autoComplete={tab === "login" ? "current-password" : "new-password"}
            />
          </div>

          {error && <p className="form-error">{error}</p>}

          <button type="submit" className="btn-primary" disabled={busy}>
            {busy ? "Please wait…" : tab === "login" ? "Sign in" : "Create account"}
          </button>
        </form>
      </div>
    </div>
  );
}
